<template>
  <b-container fluid class="animated fadeIn">
    <template v-if="consultaContribuinte === null && historicoAutuacao === null && copiaIntegral === null">
      <div class="d-flex align-items-center">
        <b-col>
          <h1 class="app-title mt-4">
            Consulta - ePAF
          </h1>
        </b-col>
      </div>
      <b-card>
        <b-alert variant="warning" show>
          <span><i class="fa fa-warning"></i>&nbsp;&nbsp;&nbsp;&nbsp;<strong>IMPORTANTE - Uso Responsável do Sistema</strong></span><br>
          <span>Para o <strong>sucesso</strong> da consulta, é <strong>necessário</strong> que o usuário esteja cadastrado na <strong>Receita Estadual do Paraná (ReceitaPR)</strong>.</span><br>
          <span>Ao prosseguir com a consulta, você <strong>consente</strong> com o registro da operação e a vinculação das suas credenciais à consulta realizada. <strong>Todas as consultas são registradas</strong> com os dados do usuário logado.</span>
        </b-alert>

        <b-row class="col-12 mb-2" style="padding-left: 30px">
          <b>Pesquisa Contribuinte:</b>
          <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
             v-b-popover.hover.top="'Consulta Contribuinte'">
          </i>
        </b-row>
        <b-row class="col-12">
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe o número CPF/CNPJ/IE:"
                label-for="docContribuinte"
                class="text-label">
              <b-form-input
                  type="text"
                  id="docContribuinte"
                  v-model="docContribuinte"
                  @input="formatarCpfCnpjIe"
                  maxlength="18"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="mt-4"/>


        <b-row class="col-12 mb-3">
          <b-col sm="12">
            <b-form-radio-group
                id="radio-tipo-relatorio"
                v-model="opcaoPesquisa"
                name="radio-tipo-relatorio"
                @change="limparOutros(2)">
              <div class="d-flex align-items-center radio-pesquisa">
                <div for="radio-dados">
                  <b>Pesquisa Dados Básicos:</b>
                  <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                     v-b-popover.hover.top="'Consulta Dados Básicos'">
                  </i>
                </div>

                <b-form-radio value="0" id="radio-dados" class="mr-5"></b-form-radio>

                <div for="radio-valores">
                  <b>Pesquisa Valores Atualizados:</b>
                  <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                     v-b-popover.hover.top="'Consulta Valores Atualizados'">
                  </i>
                </div>

                <b-form-radio value="1" id="radio-valores" class="mr-5"></b-form-radio>

                <div for="radio-historico">
                  <b>Pesquisa Histórico Autuação:</b>
                  <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                     v-b-popover.hover.top="'Consulta Histórico Autuação'">
                  </i>
                </div>

                <b-form-radio value="2" id="radio-historico" class="mr-5"></b-form-radio>

                <div for="radio-copia">
                  <b>Pesquisa Cópia Integral:</b>
                  <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
                     v-b-popover.hover.top="'Cópia Integral'">
                  </i>
                </div>

                <b-form-radio value="3" id="radio-copia"></b-form-radio>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>

        <b-row class="col-12">
          <b-col sm="6" md="3">
            <b-form-group
                label="Código Cadastro ePAF:"
                label-for="codigoCadastro"
                class="text-label">
              <b-form-input
                  type="number"
                  id="codigoCadastro"
                  v-model="codigoCadastro"
                  maxlength="18"
                  @input="limparOutros(2)"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3">
            <b-form-group
                label="Número do Auto de Infração:"
                label-for="autoInfracao"
                class="text-label">
              <b-form-input
                  type="number"
                  id="autoInfracao"
                  v-model="autoInfracao"
                  maxlength="18"
                  @input="limparOutros(2)"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="mt-4 mb-4"/>

        <div class="row justify-content-center">
          <div class="d-flex justify-content-between mb-3">
            <div>
              <b-button
                  id="btnProxima"
                  @click="pesquisar"
                  variant="primary">
                Pesquisar
              </b-button>
            </div>
          </div>
        </div>
        <CompLoading ref="loading"/>
      </b-card>
    </template>
    <template v-else>
      <b-row>
        <b-col>
          <h1 class="app-title mt-4" v-if="consultaContribuinte !== null">
            Exibir Pesquisa Contribuinte
          </h1>
          <h1 class="app-title mt-4" v-if="historicoAutuacao !== null">
            Exibir Pesquisa Histórico Autuação
          </h1>
          <h1 class="app-title mt-4" v-if="copiaIntegral !== null">
            Exibir Pesquisa Cópia Integral
          </h1>
        </b-col>
      </b-row>
      <b-card>
        <template v-if="consultaContribuinte !== null">
          <b-row class="mt-4 row-dados">
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Lista Processos ePAF</span>
                </p>
              </b-form>
            </b-col>
          </b-row>

          <b-row class="mt-4 row-dados" v-for="processo in consultaContribuinte.dados" :key="processo.codigoControleInicial">
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código Cadastro e-PAF:</span>
                  <span class="mr-sm-2 valor-dados">{{ processo.codigoControleInicial }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número do Auto de Infração:</span>
                  <span class="mr-sm-2 valor-dados">{{ processo.codigoAutoInfracao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data da Lavratura:</span>
                  <span class="mr-sm-2 valor-dados">{{ processo.dataLavratura }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação:</span>
                  <span class="mr-sm-2 valor-dados">{{ processo.statusEncerramento }}</span>
                </p>
              </b-form>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="historicoAutuacao !== null && historicoAutuacao.dados !== null">
          <b-row class="mt-4 row-dados" v-for="historico in historicoAutuacao.dados" :key="historico.numeroSequencial">
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número sequencial:</span>
                  <span class="mr-sm-2 valor-dados">{{ historico.numeroSequencial }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data da Inclusão:</span>
                  <span class="mr-sm-2 valor-dados">{{ historico.dataInclusao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Evento:</span>
                  <span class="mr-sm-2 valor-dados">{{ historico.evento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Movimentado Por:</span>
                  <span class="mr-sm-2 valor-dados">{{ historico.movimentadoPor }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação Cadastro:</span>
                  <span class="mr-sm-2 valor-dados">{{ historico.indicativoSituacaoCadastro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número Controle Manifestação:</span>
                  <span class="mr-sm-2 valor-dados">{{ historico.numeroControleManifestacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12" class="mt-2" v-if="historico.valoresCampo !== null && historico.valoresCampo.length > 0">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Referência</span>
                </p>
              </b-form>
            </b-col>
            <template v-for="campo in historico.valoresCampo">
              <b-col xs="12" sm="12" md="12">
                <b-form inline>
                  <p>
                    <span class="mr-sm-2 item-dados">Nome Campo:</span>
                    <span class="mr-sm-2 valor-dados">{{ campo.nomeCampo }}</span>
                  </p>
                </b-form>
              </b-col>
              <b-col xs="12" sm="12" md="12">
                <b-form inline>
                  <p>
                    <span class="mr-sm-2 item-dados">Valor Campo:</span>
                    <span class="mr-sm-2 valor-dados">{{ campo.valorCampo }}</span>
                  </p>
                </b-form>
              </b-col>
            </template>
          </b-row>
        </template>
        <template v-else-if="copiaIntegral !== null && copiaIntegral.dados !== null">
          <b-row class="mt-4 row-dados" v-for="copia in copiaIntegral.dados" :key="copia.idDocumento">
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">ID do Documento:</span>
                  <span class="mr-sm-2 valor-dados">{{ copia.idDocumento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">URL do Documento:</span>
                  <span class="mr-sm-2 valor-dados">
                    <a :href="copia.urlDocumento" target="_blank">{{ copia.urlDocumento }}</a>
                  </span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do Documento:</span>
                  <span class="mr-sm-2 valor-dados">{{ copia.nomeDocumento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do Arquivo:</span>
                  <span class="mr-sm-2 valor-dados">{{ copia.nomeArquivo }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data da Inclusão:</span>
                  <span class="mr-sm-2 valor-dados">{{ copia.dataInclusao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Tamanho do Arquivo:</span>
                  <span class="mr-sm-2 valor-dados">{{ copia.tamanhoArquivo }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número do Volume:</span>
                  <span class="mr-sm-2 valor-dados">{{ copia.numeroVolume }}</span>
                </p>
              </b-form>
            </b-col>
          </b-row>
        </template>

        <hr class="mt-4 mb-4"/>

        <div class="row justify-content-center">
          <div class="d-flex justify-content-between mb-3">
            <div>
              <b-button
                  class="fonte-branca ml-1"
                  variant="secondary"
                  @click.prevent="voltar()">
                <i class="fa fa-reply"></i> Voltar
              </b-button>
              <b-button
                  class="fonte-branca ml-1"
                  variant="primary"
                  @click.prevent="exportarPdf()"
              >
                <i class="fa fa-file-pdf-o"></i> Exportar PDF
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
    </template>
  </b-container>
</template>

<script>
import axios from 'axios';
import formatarMixins from '../../mixins/formatarMixins';
import store from "@/store/store";
import CompLoading from "@/views/shared/components/CompLoading.vue";

export default {
  components: {CompLoading},
  mixins: [formatarMixins],
  data() {
    return {
      urlApi: null,
      token: null,
      opcaoPesquisa: null,
      docContribuinte: null,
      codigoCadastro: null,
      autoInfracao: null,
      consultaContribuinte: null,
      dadosBasicosRetorno: null,
      valoresAtualizadosRetorno: null,
      historicoAutuacao: null,
      copiaIntegral: null
    }
  },
  methods: {
    formatarCpfCnpjIe(e) {
      this.limparOutros(1);

      let valor = e.toUpperCase().replace(/[^\w]/g, '');

      let formatado;
      if (/[a-zA-Z]/.test(valor) || valor.length > 11) {
        formatado = this.formatarCNPJ(e);
      } else if (/[a-zA-Z]/.test(valor) || valor.length > 10) {
        formatado = this.formatarCPF(e);
      } else {
        formatado = this.formatarIE(e);
      }

      this.docContribuinte = formatado;
    },

    validarCnpj(cnpj) {
      const limpo = cnpj.replace(/[^\w]/g, '').toUpperCase();
      if (!this.validarCNPJAlfanumerico(limpo)) {
        this.exibirErro(`CNPJ inválido: ${cnpj}`)
        return false
      }
      store.dispatch('limparMensagens')
      return true
    },

    validarCpfInformado(cpf) {
      if (!this.validarCpf(cpf)) {
        this.exibirErro(`CPF inválido: ${cpf}`)
        return false
      }
      store.dispatch('limparMensagens')
      return true
    },

    verificarPreenchimento(campo) {
      return campo && campo.trim() !== '';
    },

    async pesquisar() {
      store.dispatch('limparMensagens')
      if(this.verificarPreenchimento(this.docContribuinte)) {
        if (this.docContribuinte.length === 18) {
          if (!this.validarCnpj(this.docContribuinte)) {
            return
          }
        } else if (this.docContribuinte.length === 14) {
          if (!this.validarCpfInformado(this.docContribuinte)) {
            return
          }
        } else if (this.docContribuinte.length !== 12) {
          this.exibirErro(`CPF/CNPJ/IE inválido!`)
          return
        }

        this.$refs.loading.showLoading()
        axios.get(`${this.urlApi}/v1/epaf/contribuinte/${this.docContribuinte.replace(/[^\w]/g, '').toUpperCase()}`,{
          headers: {
            'Authorization': this.token,
            'Content-Type': 'application/json',
          }
        }).then(response => {
          let data = response.data;

          if (!data) {
            this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa de contribuinte.`)
            return
          }

          if (data.codigoRetorno != null) {
            const ending = data.mensagem.endsWith('.') ? '' : '.'
            this.exibirErro(`${data.mensagem}${ending}`)
            return
          }

          this.consultaContribuinte = data
        }).catch((error) => {
          this.exibirErro(error)
        }).finally(() => {
          this.$refs.loading.hideLoading()
        });
      } else if(this.verificarPreenchimento(this.codigoCadastro) || this.verificarPreenchimento(this.autoInfracao)) {
        if(this.opcaoPesquisa === null || this.opcaoPesquisa === '') {
          this.exibirErro(`Informe o tipo de Pesquisa desejado.`)
          return
        }

        const request = {
          numeroControleInicial: this.codigoCadastro ? this.codigoCadastro.replace(/[^\w]/g, '') : null,
          codigoAutoInfracao: this.autoInfracao ? this.autoInfracao.replace(/[^\w]/g, '') : null
        }

        this.$refs.loading.showLoading()

        if(this.opcaoPesquisa === "0") {
          axios.post(`${this.urlApi}/v1/epaf/dadosBasicos`, request,{
            headers: {
              'Authorization': this.token,
              'Content-Type': 'application/json',
            }
          }).then(response => {
            let data = response.data

            if (!data) {
              this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa de dados básicos.`)
              return
            }

            if (data.codigoRetorno != null) {
              const ending = data.mensagem.endsWith('.') ? '' : '.'
              this.exibirErro(`${data.mensagem}${ending}`)
              return
            }

            this.dadosBasicosRetorno = data

            this.exportarPdf()

            this.limpar()
          }).catch((error) => {
            this.exibirErro(error)
          }).finally(() => {
            this.$refs.loading.hideLoading()
          });
        } else if(this.opcaoPesquisa === "1") {
          axios.post(`${this.urlApi}/v1/epaf/valoresAtualizados`, request,{
            headers: {
              'Authorization': this.token,
              'Content-Type': 'application/json',
            }
          }).then(response => {
            let data = response.data

            if (!data) {
              this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa de valores atualizados.`)
              return
            }

            if (data.codigoRetorno != null) {
              const ending = data.mensagem.endsWith('.') ? '' : '.'
              this.exibirErro(`${data.mensagem}${ending}`)
              return
            }

            this.valoresAtualizadosRetorno = data

            this.exportarPdf()

            this.limpar()
          }).catch((error) => {
            this.exibirErro(error)
          }).finally(() => {
            this.$refs.loading.hideLoading()
          });
        } else if(this.opcaoPesquisa === "2") {
          axios.post(`${this.urlApi}/v1/epaf/historicoAutuacao`, request,{
            headers: {
              'Authorization': this.token,
              'Content-Type': 'application/json',
            }
          }).then(response => {
            let data = response.data

            if (!data) {
              this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa de histórico de autuação.`)
              return
            }

            if (data.codigoRetorno != null) {
              const ending = data.mensagem.endsWith('.') ? '' : '.'
              this.exibirErro(`${data.mensagem}${ending}`)
              return
            }

            this.historicoAutuacao = data
          }).catch((error) => {
            this.exibirErro(error)
          }).finally(() => {
            this.$refs.loading.hideLoading()
          });
        } else if(this.opcaoPesquisa === "3") {
          axios.post(`${this.urlApi}/v1/epaf/copiaIntegral`, request,{
            headers: {
              'Authorization': this.token,
              'Content-Type': 'application/json',
            }
          }).then(response => {
            let data = response.data

            if (!data) {
              this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa de cópia integral.`)
              return
            }

            if (data.codigoRetorno != null) {
              const ending = data.mensagem.endsWith('.') ? '' : '.'
              this.exibirErro(`${data.mensagem}${ending}`)
              return
            }

            this.copiaIntegral = data
          }).catch((error) => {
            this.exibirErro(error)
          }).finally(() => {
            this.$refs.loading.hideLoading()
          });
        }
      } else if(this.opcaoPesquisa === null || this.opcaoPesquisa === '') {
        this.exibirErro(`Campo documento é obrigatório.`)
      } else {
        this.exibirErro(`Informe ao menos um dos campos: Número Controle Inicial ou Código do Auto de Infração.`)
      }
    },

    voltar() {
      this.limpar()
      store.dispatch('limparMensagens');
    },

    limparOutros(pesquisa) {
      store.dispatch('limparMensagens');
      if(pesquisa === 1) {
        this.codigoCadastro = null;
        this.autoInfracao = null;
        this.opcaoPesquisa = null;
      } else {
        this.docContribuinte = null;
      }
    },

    limpar() {
      this.opcaoPesquisa = null
      this.docContribuinte = null
      this.codigoCadastro = null
      this.autoInfracao = null
      this.consultaContribuinte = null
      this.dadosBasicosRetorno = null
      this.valoresAtualizadosRetorno = null
      this.historicoAutuacao = null
      this.copiaIntegral = null
    },

    exportarPdf() {
      let nomeArquivo;
      let base64;
      if (this.consultaContribuinte !== null) {
        nomeArquivo = `pesquisa_contribuinte.pdf`
        base64 = this.consultaContribuinte.pdf
      } else if (this.dadosBasicosRetorno !== null) {
        nomeArquivo = `pesquisa_dados_basicos.pdf`
        base64 = this.dadosBasicosRetorno.pdf
      } else if (this.valoresAtualizadosRetorno !== null) {
        nomeArquivo = `pesquisa_valores_atualizados.pdf`
        base64 = this.valoresAtualizadosRetorno.pdf
      } else if (this.historicoAutuacao !== null) {
        nomeArquivo = `pesquisa_historico_autuacao.pdf`
        base64 = this.historicoAutuacao.pdf
      } else if (this.copiaIntegral !== null) {
        nomeArquivo = `pesquisa_copia_integral.pdf`
        base64 = this.copiaIntegral.pdf
      }

      this.downloadArquivo(base64, nomeArquivo, 'application/pdf')
    },

    downloadArquivo(base64, nomeArquivo, contentType) {
      var a = document.createElement("a");
      a.href = `data:${contentType};base64,${base64}`;
      a.download = nomeArquivo
      a.click()
    }
  },

  mounted() {
    this.$store.commit("setMessages", {});
    this.urlApi = process.env.VUE_APP_ROOT_API;
    this.token = JSON.parse(this.$store.getters.getUser).access_token;
  }

}
</script>

<style>
  .row-dados {
    padding-left: 10%;
    padding-right: 10%;
  }
  .item-dados {
    color: #5C78B3;
    font-weight: bold;
    font-size: 0.87rem;
  }
  .valor-dados {
    color: #8ba2d7;
  }
  .valor-dados a {
    word-break: break-all;
  }
  .item-direita {
    border-left: 2px solid black;
  }
  .table-sociedade {
    text-align: center;
  }
  .table-sociedade table th {
    color: #5C78B3 !important;
    font-weight: bold;
    font-size: 0.87rem;
  }
  .table-sociedade table td {
    color: #8ba2d7;
  }
  .radio-pesquisa .custom-control.custom-control-inline.custom-radio {
    padding-top: 0 !important;
    margin-left: 10px !important;
  }
  .radio-pesquisa .custom-control.custom-control-inline.custom-radio label::after {
    cursor: pointer;
  }
</style>
